import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import styles from './SearchResult.module.css'
import { patientActions, searchActions } from '_actions'

class SearchResult extends React.Component {

    openPatient() {
        this.props.openPatient(this.props.result.id);
        this.props.quickSearchClear();
    }

    render() {
        return (
            <span className={styles.result} id={this.props.result.id} onClick={() => this.openPatient()}>{this.props.result.details}</span>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        result: state.entities.quickSearch[ownprops.id]
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openPatient: bindActionCreators(patientActions.open, dispatch),
        quickSearchClear: bindActionCreators(searchActions.quickSearchClear, dispatch),
    };
}


const connectedSearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResult);
export { connectedSearchResult as SearchResult };